import type { FieldError } from 'react-hook-form';
import type { FieldValidationError } from '../../types/cloud_api_error_type';

type FormErrorMessageProps = {
  formError: FieldError | FieldValidationError | undefined;
};

export const FormErrorMessage = ({ formError }: FormErrorMessageProps) => {
  return (
    <>
      {formError && (
        <ul className="parsley-errors-list mg-b-minus-8">
          <li className="parsley-type">{formError.message}</li>
        </ul>
      )}
    </>
  );
};
